// eslint-disable-next-line
URL = 'https://basecamp-rails.herokuapp.com/api/v1/'

// Local URL for testing
// URL = 'http://localhost:5000/api/v1/'
